import { Col, Row } from "reactstrap"

import { getTopSoldProducts, getLowSoldProducts } from "services/tickets"
import RankedProductsCard from "./RankedProductsCard"
import useDashboardQuery from "../useDashboardQuery"

const currencyFormatter = new Intl.NumberFormat("es-MX", {
  style: "currency",
  currency: "MXN",
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
})

const truncateProductName = (name) => String(name || "Sin nombre").slice(0, 15)

const DashboardProductsSection = () => {
  const topSoldProductsQuery = useDashboardQuery(
    ["dashboard-top-sold-products"],
    () => getTopSoldProducts(),
    { staleTime: 1000 * 60 * 15 }
  )

  const topProducts = (topSoldProductsQuery.data || []).map((product) => ({
    name: truncateProductName(product.name),
    fullName: product.name || "Sin nombre",
    amount: currencyFormatter.format(Number(product.amount || 0)),
    units: `${Math.round(Number(product.units || 0))} uds`,
  }))

  const lowSoldProductsQuery = useDashboardQuery(["dashboard-low-sold-products"], () => getLowSoldProducts(), {
    staleTime: 1000 * 60 * 15,
  })

  const lowProducts = (lowSoldProductsQuery.data || []).map((product) => ({
    name: truncateProductName(product.name),
    fullName: product.name || "Sin nombre",
    amount: currencyFormatter.format(Number(product.amount || 0)),
    units: `${Math.round(Number(product.units || 0))} uds`,
  }))

  return (
    <Row className="g-3">
      <Col xl="6" lg="6" md="6" xs="12">
        <RankedProductsCard
          title="Top 10 productos más vendidos"
          description="Productos con mayor salida"
          items={topProducts}
          isLoading={topSoldProductsQuery.isLoading}
          hasError={topSoldProductsQuery.isError}
        />
      </Col>
      <Col xl="6" lg="6" md="6" xs="12">
        <RankedProductsCard
          title="Top 10 productos menos vendidos"
          description="Productos con menor rotación"
          items={lowProducts}
          isLoading={lowSoldProductsQuery.isLoading}
          hasError={lowSoldProductsQuery.isError}
        />
      </Col>
    </Row>
  )
}

export default DashboardProductsSection